<app-device-add
  [userObject]="userObject"
  [dialogRef]="dialogRef"
>
</app-device-add>
